import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionGroupsParams } from 'src/apis/authorization-service/types';
import { AuthorizationServiceRequest } from 'src/apis/authorization-service/use-authorization-service';
import { usePermissionGroup } from 'src/apis/authorization-service/use-permission-group';
import { usePermissionGroups } from 'src/apis/authorization-service/use-permission-groups';
import { usePermissions } from 'src/apis/authorization-service/use-permissions';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

const permissionGroupsParams: PermissionGroupsParams = {
  limit: 0, // we just need the instance link
};

const Page = lazy(() => import('./page'));

type Props = {
  authorizationService: Successful<AuthorizationServiceRequest>;
};

export const PermissionGroupsDetails: FC<Props> = ({
  authorizationService,
}) => {
  const { permissionGroupId } = useParams<{ permissionGroupId: string }>();
  const permissionGroups = usePermissionGroups({
    authorizationService,
    params: permissionGroupsParams,
  });
  const permissionGroup = usePermissionGroup({
    permissionGroups,
    permissionGroupId,
  });

  const permissions = usePermissions({ authorizationService });

  if (!permissions) throw new Forbidden();
  if (!permissionGroup) throw new Forbidden();

  if (!permissions.response || !permissionGroup.response)
    return <PageSpinner />;

  return <Page permissions={permissions} permissionGroup={permissionGroup} />;
};
